import { makeActionCreator } from '../../../../../utilities'
import { PupilsConstants } from './pupils.constants'

export const setPupilSizeL = makeActionCreator(PupilsConstants.SET_PUPILSIZEL, 'pupilSizeL')
export const setPupilRxL = makeActionCreator(PupilsConstants.SET_PUPILRXL, 'pupilRxL')
export const setPupilSizeR = makeActionCreator(PupilsConstants.SET_PUPILSIZER, 'pupilSizeR')
export const setPupilRxR = makeActionCreator(PupilsConstants.SET_PUPILRXR, 'pupilRxR')
export const setHeadReactive = makeActionCreator(PupilsConstants.SET_HEADREACTIVE, 'headReactive')

export const savePupils = makeActionCreator(PupilsConstants.SAVE_PUPILS)
export const setPupilsResponse = makeActionCreator(PupilsConstants.SET_RESPONSE, 'response')
export const setPupils = makeActionCreator(PupilsConstants.SET_PUPILS, 'pupils')
export const resetPupilsState = makeActionCreator(PupilsConstants.RESET_PUPILS_STATE)
